import classNames from 'classnames';

import { Typography } from '@/shared/components/atoms';

import Warning from '~/images/shared/Wraning.svg';

// TODO: refactor => generic component
interface IProps {
  type: 'warning' | 'danger';
  message: string;
  className?: string;
}

const Alert: React.FC<IProps> = ({ type, message, className }) => (
  <div
    className={classNames(
      className,
      'flex items-center gap-8 rounded-xl p-16',
      type === 'warning' && 'bg-neutralVariant-96 text-tertiary-20',
      type === 'danger' && 'bg-error-90 text-error-20'
    )}
  >
    <span>
      <Warning width='24' height='24' />
    </span>
    <Typography weight='semiBold' variant='body1'>
      {message}
    </Typography>
  </div>
);

export default Alert;
